import {z} from 'zod';

export const BiddingResponseSummarySchema = z.object({
  id: z.string(),
  project_id: z.coerce.number(),
  bid_package_id: z.coerce.number().optional(),
  total_invited: z.coerce.number(),
  total_available: z.coerce.number(),
  total_yes: z.coerce.number(),
  total_no: z.coerce.number(),
  total_unsure: z.coerce.number(),
  total_unconfirmed: z.coerce.number(),
});

export type BiddingResponseSummary = z.infer<typeof BiddingResponseSummarySchema>;
